<script>
import {Carousel, Slide} from "vue3-carousel";
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import {useStore} from "vuex";
import BottomNavigationWorker from "@/components/assetComponents/BottomNavigationWorker.vue";

export default {
  name: "W_HomePage",
  components: {BottomNavigationWorker, Slide, Carousel},
  setup() {

    let store = useStore()

    let slider = ref(FreeWorld.PinkMan(store.state.slider, 'de'))
    let info_user = ref(FreeWorld.PinkMan(store.state.profile , 'de'))

    return {
      slider,
      info_user,
    }
  }
}
</script>

<template>

  <div id="main" class="bg-color-liner">

    <router-link :to="{name:'W_ProfileWorker'}" class="text-decoration-none d-flex align-items-center p-4">
      <img class="img-profile rounded-pill ms-3 icon_shadow" :src="info_user.pic" alt="">
      <p class="text-white font-bold font-4">{{ info_user.name }}</p>
    </router-link>

    <div style="height: calc(100% - 9rem);" id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div class="slider rounded-4 mb-5">
        <carousel class="w-100 h-100" :items-to-show="1" :wrapAround="true" :transition="2000" :autoplay="3000" :pauseAutoplayOnHover="true">
          <slide v-for="item in slider" :key="item.index" class="w-100 h-100 px-2 rounded-4">
            <img :src="item" class="slider w-100 rounded-4" alt="">
          </slide>
        </carousel>
      </div>

      <router-link :to="{name:'W_MyCustomer'}" class="w-100 text-decoration-none d-flex justify-content-between mt-5">
        <div class="w-25 p-3 rounded-5 shadow-KhA d-flex justify-content-center align-items-center">
          <img src="../assets/img/icon-my_moshtary.png" class="icon-size-7">
        </div>
        <div class="w-70  p-3 rounded-5 shadow-KhA d-flex justify-content-center align-items-center">
          <p class="font-4 font-bold text-color">مشتریان من</p>
        </div>
      </router-link>

      <router-link :to="{name:'W_ReportingService'}" class="w-100 text-decoration-none d-flex justify-content-between mt-4">
        <div class="w-25 p-3 rounded-5 shadow-KhA d-flex justify-content-center align-items-center">
          <img src="../assets/img/icon-my-servise.png" class="icon-size-7">
        </div>
        <div class="w-70  p-3 rounded-5 shadow-KhA d-flex justify-content-center align-items-center">
          <p class="font-4 font-bold text-color">سرویس ها من</p>
        </div>
      </router-link>

      <router-link :to="{name:'EmergencyNumbers'}" class="w-100 text-decoration-none d-flex justify-content-between mt-4">
        <div class="w-25 p-3 rounded-5 shadow-KhA d-flex justify-content-center align-items-center">
          <img src="../assets/img/icon-phone-emergency.png" class="icon-size-7">
        </div>
        <div class="w-70  p-3 rounded-5 shadow-KhA d-flex justify-content-center align-items-center">
          <p class="font-4 font-bold text-color">شماره های اضطراری</p>
        </div>
      </router-link>

      <BottomNavigationWorker></BottomNavigationWorker>

    </div>
  </div>

</template>

<style scoped>
.img-profile {
  width: 3rem;
  height: 3rem;
}
.shadow-KhA {
  box-shadow: 0px 8px 18px rgba(189, 215, 234, 0.6);
}
.slider {
  height: 15rem;
}
</style>